import { useCallback, useState } from "react";
import { useAuth } from "@shared/lib/auth";
import { useSubscriptionSync } from "@shared/lib/useSubscriptionSync";
import { AdminShell } from "./AdminShell";
import { Spinner } from "@shared/components/ui";
import { UpgradeSuccessModal } from "../UpgradeSuccessModal";

export function RoleBasedShell() {
  const auth = useAuth();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const handleUpgrade = useCallback(() => setShowUpgradeModal(true), []);

  // Sync subscription data and show modal/toast when plan changes (e.g., admin upgrades)
  useSubscriptionSync({ onUpgrade: handleUpgrade });

  // Show spinner while loading auth status
  if (auth.status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg">
        <Spinner label="Loading..." />
      </div>
    );
  }

  // Safety net: prevent parent/teacher from rendering AdminShell (redirect handles this,
  // but if they somehow reach here, show a spinner instead of a dead view)
  if (auth.user && (auth.user.role === "parent" || auth.user.role === "teacher")) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg">
        <Spinner label="Redirecting…" />
      </div>
    );
  }

  // Admin and Director both use AdminShell (access gated by permissions)
  return (
    <>
      <AdminShell />
      <UpgradeSuccessModal
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
      />
    </>
  );
}
